import { subtractBusinessDays } from "@sellar-io/common";
import dayjs from "dayjs";

export const getOrderByDateTime = ({
  nextDeliveryDate,
  orderCutOffTime,
  orderCutOffDaysBefore,
  includeWeekend,
}: {
  nextDeliveryDate: Date | null;
  orderCutOffTime: Date | null;
  orderCutOffDaysBefore: number | null;
  includeWeekend: boolean;
}) => {
  if (!nextDeliveryDate) {
    return null;
  }

  // orderCutOffTime is stored as utc
  const providedCutoffTimeUtc = orderCutOffTime
    ? dayjs(orderCutOffTime).utc()
    : undefined;

  const cutOffHour = providedCutoffTimeUtc?.get("hour") ?? 23;
  const cutOffMinute = providedCutoffTimeUtc?.get("minute") ?? 59;

  const nextDeliveryDateLocal = dayjs(nextDeliveryDate).utc();

  const cutoffBase = includeWeekend
    ? nextDeliveryDateLocal.subtract(orderCutOffDaysBefore ?? 0, "day")
    : subtractBusinessDays(nextDeliveryDateLocal, orderCutOffDaysBefore ?? 0);

  return cutoffBase.set("hour", cutOffHour).set("minute", cutOffMinute);
};
